export const HEADER_CSS_CLASS = 'js-default-layout-header';
export const SCROLL_TO_OFFSET = 10; // in px
